import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { validateImageFile, readFileAsDataURL } from '../utils/fileValidation';

const useEventForm = (initialData) => {
  const [formData, setFormData] = useState(initialData);

  const updateField = useCallback((name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleChange = useCallback(async (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      const file = files && files[0];
      const { valid, error } = validateImageFile(file);
      if (!valid) {
        toast.error(error);
        e.target.value = '';
        return;
      }
      try {
        const dataUrl = await readFileAsDataURL(file);
        setFormData((prev) => ({
          ...prev,
          immagineCopertina: dataUrl,
          fileName: file.name,
        }));
      } catch {
        toast.error('Errore durante la lettura del file');
      }
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  return { formData, setFormData, updateField, handleChange };
};

export default useEventForm;
